import { render, staticRenderFns } from "./SubjectCrud.vue?vue&type=template&id=0888acac&scoped=true"
import script from "./SubjectCrud.vue?vue&type=script&lang=js"
export * from "./SubjectCrud.vue?vue&type=script&lang=js"
import style0 from "./SubjectCrud.vue?vue&type=style&index=0&id=0888acac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888acac",
  null
  
)

export default component.exports